<template>
  <b-form @submit.prevent="saveForm">
    <b-form-row>
      <b-col cols="12" lg="6">
        <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
          <template slot="label">
            {{ $gettext('Date') }}
          </template>
          <b-form-datepicker id="input-1" v-model="item.date" no-flip initial-date="2021-01-01" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" />
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="6">
        <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" :label="$gettext('Amount*')" label-for="input-2">
          <b-form-input v-model="item.amount" type="number" required />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-3">
          <b-form-textarea v-model="item.description" :placeholder="$gettext('Insert investment description')" rows="6" />
        </b-form-group>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import BalanceSheetService from "@/store/services/balancesheet.service";

export default {
  name: "AddEditItem",
  components: {},
  data() {
    return {
      item: {
        date: new Date(),
        description: null,
        amount: 0,
        writeoffyears_count: 0,
        writeoffyear_set: []
      }
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId',
    }),
  },
  created() {
    if (this.$route.params['investmentId']) { // edit
      BalanceSheetService.retrieve(this.$route.params['investmentId']).then(response => {
        this.item = response.data;
      });
    }
  },
  methods: {
    ...mapMutations({
        setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
    }),
    saveForm() {
      this.setWaitingForResponse(true);
      let data = BalanceSheetService.prepareDataForUpdate(this.item);
      data.company_profile = this.getCompanyId;
      if (this.$route.params['investmentId']) { // edit
        BalanceSheetService.update(this.item.id, data).then((response) => {
          this.$emit("edited", response.data);
        }).catch((response) => {
          let msg = this.$gettext("Error updating the investment item.");
          if (response["amount"])
              msg = response["amount"];
          this.$store.commit("setAlert", {
              title: this.$gettext("Something went wrong"),
              text: msg,
              variant: "danger",
              duration: 4
          });
          if (window.mixpanel) {
            window.mixpanel.track("Balance Sheet: item edited");
          }
        }).finally(() => {
          this.setWaitingForResponse(false);
        });
      } else { // add
        BalanceSheetService.create(data).then((response) => {
          this.$emit("created", response.data);
        }).catch((error) => {
          let msg = this.$gettext("Error updating the investment item.");
          if (error.data["amount"])
              msg = error.data["amount"];
          else if (error.data["description"])
              msg = this.$gettext("Please fill in a description of the investment.");
          this.$store.commit("setAlert", {
              title: this.$gettext("Something went wrong"),
              text: msg,
              variant: "danger",
              duration: 4
          });
          if (window.mixpanel) {
            window.mixpanel.track("Balance Sheet: item created");
          }
        }).finally(() => {
          this.setWaitingForResponse(false);
        });
      }
    }
  }
}
</script>

<style scoped>

</style>